import React from 'react';

function GameProperties({ properties }) {
  if (!properties) return null;

  const getPlatformIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'windows':
        return 'desktop_windows';
      case 'mac':
        return 'laptop_mac';
      case 'android':
        return 'android';
      case 'ios':
        return 'phone_iphone';
      case 'linux':
        return 'computer';
      default:
        return 'devices';
    }
  };

  return (
    <div className="bg-gradient-to-br from-dark-card to-dark-surface border border-dark-border rounded-3xl p-6 lg:p-8">
      <h2 className="text-xl lg:text-2xl font-semibold text-white mb-4 lg:mb-6">Game Details</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {properties.version && (
          <div>
            <div className="text-white/50 text-xs uppercase tracking-wider mb-1">Version</div>
            <div className="text-white text-sm md:text-base font-medium">{properties.version}</div>
          </div>
        )}
        {properties.size && (
          <div>
            <div className="text-white/50 text-xs uppercase tracking-wider mb-1">Size</div>
            <div className="text-white text-sm md:text-base font-medium">{properties.size}</div>
          </div>
        )}
        {properties.language && (
          <div>
            <div className="text-white/50 text-xs uppercase tracking-wider mb-1">Language</div>
            <div className="text-white text-sm md:text-base font-medium">{properties.language}</div>
          </div>
        )}
        {properties.gameEngine && (
          <div>
            <div className="text-white/50 text-xs uppercase tracking-wider mb-1">Engine</div>
            <div className="text-white text-sm md:text-base font-medium">{properties.gameEngine}</div>
          </div>
        )}
        {properties.status && (
          <div>
            <div className="text-white/50 text-xs uppercase tracking-wider mb-1">Status</div>
            <div className="text-white text-sm md:text-base font-medium">{properties.status}</div>
          </div>
        )}
        {properties.playtime && (
          <div>
            <div className="text-white/50 text-xs uppercase tracking-wider mb-1">Playtime</div>
            <div className="text-white text-sm md:text-base font-medium">{properties.playtime}</div>
          </div>
        )}
      </div>
      {properties.platforms && properties.platforms.length > 0 && (
        <div className="mt-4 pt-4 border-t border-dark-border">
          <div className="text-white/50 text-xs uppercase tracking-wider mb-3">Platforms</div>
          <div className="flex flex-wrap gap-3">
            {properties.platforms.map((platform, index) => (
              <div
                key={index}
                className="flex items-center gap-2 px-3 py-2 rounded-lg bg-dark-surface/50 border border-dark-border"
              >
                <span className="material-icons text-lg text-white/80">
                  {getPlatformIcon(platform)}
                </span>
                <span className="text-white text-sm md:text-base font-medium">{platform}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default GameProperties;

